import Vue, { Component } from "vue";
import VueRouter from "vue-router";
import type { RouteConfig, RouterOptions } from "vue-router";

Vue.use(VueRouter);

let isLogin = false;

const routes: Array<RouteConfig> = [
  // {
  //   path: "/",
  //   name: "login",
  //   component: () => import("../views/Login.vue"),
  // },
  {
    path: "/",
    name: "index",
    component: () => import("../views/Home.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
} as RouterOptions);

// router.beforeEach((to, from, next) => {
//   // if (to.name === "home" && from.name === "home") {
//   //   isLogin = true;
//   // }
//   // if (to.name !== "home" && !isLogin) {
//   //   next({ name: 'home' });
//   // } else {
//   //   next();
//   // }
// });

export function useRouter() {
  return router;
}

export function useRoute() {
  return router.currentRoute;
}

export default router;
